"use strict";
/*
 * Created on 01 16 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Converter for {@link ProductVATByProduct data of aggregation}
 *
 * @author JMe
 */


var ProductVATByProductDataConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductVATByProductDataConverter, _DataObjectConverter_);

  function ProductVATByProductDataConverter() {
    _classCallCheck(this, ProductVATByProductDataConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductVATByProductDataConverter).apply(this, arguments));
  }

  return ProductVATByProductDataConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductVATByProductDataConverter = ProductVATByProductDataConverter;